import { LogoMark } from "./Logo";

const TH = ({ children, className = "" }) => <th className={`text-[9px] font-bold ${className}`}>{children}</th>;
const TD = ({ children, className = "" }) => <td className={`text-[10px] ${className}`}>{children}</td>;
const fmtDate = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("id-ID", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });
const fmtTime = (iso) => new Date(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });

/** Daftar Repair harian — satu lembar A4 per vendor untuk tindak lanjut workshop */
export function RepairPrintView({ data, user }) {
  if (!data.vendors.length) {
    return (
      <div className="print-sheet" data-testid="repair-print-empty">
        <div className="py-20 text-center text-sm">Tidak ada scan Repair pada {fmtDate(data.date)}.</div>
      </div>
    );
  }
  return data.vendors.map((v, vi) => (
    <div key={v.vendorName} className="print-sheet" data-testid={`repair-print-sheet-${vi}`}>
      <div className="grid grid-cols-3 items-start gap-3 border-b-2 border-black pb-3">
        <div className="flex items-center gap-2">
          <LogoMark size={46} />
          <div className="leading-tight">
            <div className="font-display text-[12px] font-bold">PT HONGLU BAJA INDONESIA</div>
            <div className="cn text-[9px]">宏睿钢印印尼有限公司</div>
          </div>
        </div>
        <div className="text-center leading-tight">
          <div className="font-display text-2xl font-black tracking-widest text-red-700">REPAIR</div>
          <div className="font-display text-[11px] font-bold">DAFTAR TINDAK LANJUT PERBAIKAN QC</div>
          <div className="cn text-[10px]">质检返修跟进清单</div>
        </div>
        <div className="space-y-0.5 text-[9px]">
          <div><b>Tanggal / <span className="cn">日期</span>:</b> {fmtDate(data.date)}</div>
          <div><b>Vendor / <span className="cn">供应商</span>:</b> {v.vendorSingkatan ? `${v.vendorName} (${v.vendorSingkatan})` : v.vendorName}</div>
          <div><b>Jumlah Repair / <span className="cn">返修数</span>:</b> <span className="font-mono font-bold">{v.items.length}</span> item</div>
          <div><b>Dicetak oleh / <span className="cn">打印人</span>:</b> {user?.name || "Admin"}</div>
        </div>
      </div>

      <table className="mt-3">
        <thead>
          <tr className="bg-gray-100">
            <TH className="w-8">No</TH>
            <TH>Jam / <span className="cn">时间</span></TH>
            <TH>Marking / <span className="cn">构件编号</span></TH>
            <TH>Proyek / <span className="cn">项目</span></TH>
            <TH>SPK</TH>
            <TH>Profile / <span className="cn">规格</span></TH>
            <TH>Area</TH>
            <TH>Catatan Defect / <span className="cn">缺陷说明</span></TH>
            <TH>QC Oleh / <span className="cn">检验员</span></TH>
            <TH>Selesai Repair / <span className="cn">返修完成（手写）</span></TH>
          </tr>
        </thead>
        <tbody>
          {v.items.map((it, i) => (
            <tr key={`${it.code}-${it.at}`}>
              <TD className="text-center">{i + 1}</TD>
              <TD className="text-center font-mono">{fmtTime(it.at)}</TD>
              <TD className="font-mono font-bold">{it.code}</TD>
              <TD>{it.projectName}</TD>
              <TD className="font-mono text-[9px]">{it.spkNo || "—"}</TD>
              <TD>{it.profile || "—"}</TD>
              <TD className="text-center">{it.area || "—"}</TD>
              <TD>{it.note || <span className="text-gray-400">—</span>}</TD>
              <TD className="text-[9px]">{it.by}</TD>
              <TD className="h-6" />
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-6 grid grid-cols-4 gap-2 text-[8px]">
        {["QC / 质检", "Vendor / 供应商", "Kepala Area / 区域负责人", "Verifikasi Ulang QC / 复检"].map((t, i) => (
          <div key={t} className="sig-block text-center leading-relaxed">
            <div className="font-bold">{t}</div>
            {i === 1 ? <div className="truncate text-[8px] text-gray-700">{v.vendorName}</div> : <div className="h-3" />}
            <div className="h-9" />
            <div className="border-t border-black pt-0.5 pl-1 text-left">Nama / <span className="cn">姓名</span>:</div>
            <div className="mt-1 pl-1 text-left">Tanggal / <span className="cn">日期</span>:</div>
          </div>
        ))}
      </div>

      <div className="mt-3 flex justify-between text-[9px] text-gray-500">
        <span>Vendor {vi + 1} dari {data.vendors.length}</span>
        <span>{new Date().toLocaleString("id-ID", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })}</span>
      </div>
    </div>
  ));
}
